import React from "react";
import Loginpage from "../Components/Login/Loginpage";

const Login = () => {
  return <Loginpage />;
};

export default Login;
